import { APIClientServices } from "./APIClientServices";

export interface MemberLibraryModelConfigDTO {
	provider: string;
	name: string;
	temperature?: number | null;
	max_tokens?: number | null;
	maxTokens?: number | null;
}

export interface PublicMemberLibraryDTO {
	id: string;
	slug: string;
	name: string;
	description: string | null;
	systemPrompt: string;
	modelConfig: MemberLibraryModelConfigDTO;
	seniorityConfig: Record<string, any>;
	mcpIds: string[];
	isActive: boolean;
	createdAt: string;
	updatedAt: string;
}

export interface CreateMemberLibraryPayload {
	slug: string;
	name: string;
	system_prompt: string;
	description?: string;
	model_config?: MemberLibraryModelConfigDTO;
	seniority_config?: Record<string, any>;
	mcp_ids?: string[];
	is_active?: boolean;
}

export interface UpdateMemberLibraryPayload {
	slug?: string;
	name?: string;
	system_prompt?: string;
	description?: string;
	model_config?: MemberLibraryModelConfigDTO;
	seniority_config?: Record<string, any>;
	mcp_ids?: string[];
	is_active?: boolean;
}

export class MemberLibraryServices {
	private static readonly WORKSPACE_ROUTE = "v1/workspaces";
	private static readonly BACKOFFICE_ROUTE = "v1/backoffice/member-library";

	/** Lista templates de member library visíveis no workspace (fluxo de contratação do usuário). */
	static async listForWorkspace(workspaceId: string, activeOnly: boolean = true): Promise<PublicMemberLibraryDTO[]> {
		return APIClientServices.get<PublicMemberLibraryDTO[]>(`${this.WORKSPACE_ROUTE}/${workspaceId}/member-library`, {
			activeOnly: activeOnly ? "true" : "false",
		});
	}

	/** Obtém detalhes de um template específico para o workspace. */
	static async getForWorkspace(workspaceId: string, memberLibraryId: string): Promise<PublicMemberLibraryDTO> {
		return APIClientServices.get<PublicMemberLibraryDTO>(`${this.WORKSPACE_ROUTE}/${workspaceId}/member-library/${memberLibraryId}`);
	}

	/** Lista todos os templates (admin — sem filtro de workspace). */
	static async listAll(): Promise<PublicMemberLibraryDTO[]> {
		return APIClientServices.get<PublicMemberLibraryDTO[]>(this.BACKOFFICE_ROUTE);
	}

	/** Cria template de member library no backoffice (ADMIN+). */
	static async create(payload: CreateMemberLibraryPayload): Promise<PublicMemberLibraryDTO> {
		return APIClientServices.post<PublicMemberLibraryDTO>(this.BACKOFFICE_ROUTE, payload);
	}

	/** Atualiza template de member library no backoffice (ADMIN+). */
	static async update(memberLibraryId: string, payload: UpdateMemberLibraryPayload): Promise<PublicMemberLibraryDTO> {
		return APIClientServices.put<PublicMemberLibraryDTO>(`${this.BACKOFFICE_ROUTE}/${memberLibraryId}`, payload);
	}

	/** Desativa template de member library no backoffice (ADMIN+). */
	static async delete(memberLibraryId: string): Promise<{ message: string }> {
		return APIClientServices.delete<{ message: string }>(`${this.BACKOFFICE_ROUTE}/${memberLibraryId}`);
	}
}
